// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PrometheusInstancesController = function ($scope, $http, PrometheusInstance) {
    const title = "Prometheus Action";
    $scope.instances = PrometheusInstance.query();

    function getInstancesModes() {
        $scope.instances = PrometheusInstance.query();
    }

    function resetState(instance) {
        instance.LockedAt = null;
        instance.ProcessingMode = 'Loop';
        $http.post("/api/v1/prometheusInstance/" + instance.Id, instance).success(function () {
            getInstancesModes();
        });
    }

    function changeMode(instance) {
        $http.post("/api/v1/prometheusInstance/" + instance.Id, instance).success(function () {
            $scope.instances = PrometheusInstance.query();
        });
    }

    $scope.changeMode = function (instance) {
        $scope.confirm(title, "Are you sure you want to change the processing mode?", changeMode.bind(this, instance), getInstancesModes)
    };

    $scope.resetState = function (instance) {
        $scope.confirm(title, "Are you sure you want to reset Locked At?", resetState.bind(this, instance))
    }
    
};
PrometheusInstancesController.$inject = ['$scope', '$http', 'PrometheusInstance'];
